/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Colleague_Action_Download_AddressesInputs */

const en_colleague_action_download_addresses = /** @type {(inputs: Colleague_Action_Download_AddressesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download addresses`)
};

const ja_colleague_action_download_addresses = /** @type {(inputs: Colleague_Action_Download_AddressesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`住所をダウンロード`)
};

const fr_colleague_action_download_addresses = /** @type {(inputs: Colleague_Action_Download_AddressesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Télécharger les adresses`)
};

const de_colleague_action_download_addresses = /** @type {(inputs: Colleague_Action_Download_AddressesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adressen herunterladen`)
};

/**
* | output |
* | --- |
* | "Download addresses" |
*
* @param {Colleague_Action_Download_AddressesInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const colleague_action_download_addresses = /** @type {((inputs?: Colleague_Action_Download_AddressesInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Colleague_Action_Download_AddressesInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_colleague_action_download_addresses(inputs)
	if (locale === "ja") return ja_colleague_action_download_addresses(inputs)
	if (locale === "fr") return fr_colleague_action_download_addresses(inputs)
	return de_colleague_action_download_addresses(inputs)
});